import "./TodoItem.css";
import { Switch } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

function TodoItem(props) {
  // const onComplete = (text) => {
  //     alert(`completaste la tarea ${text}`)
  // }

  // const onDelete = (text) => {
  //     alert(`borraste la tarea ${text}`)
  // }

  return (
    <>
      <li className="my-4 p-4 relative flex justify-between items-center w-full bg-white dark:bg-gray-700 drop-shadow-md rounded-md">
        {/* <button
        className={`btn btn-complete ${props.completed ? "btn-active" : ""}`}
        onClick={props.onComplete}
      >
        √
      </button> */}

        <div>
          <Switch
            checked={props.completed}
            onChange={props.onComplete}
            className={`${
              props.completed ? "bg-emerald-500" : "bg-gray-200 dark:bg-gray-900"
            } relative inline-flex h-6 w-11 items-center rounded-full`}
          >
            <span className="sr-only">Complete</span>
            <span
              className={`${
                props.completed ? "translate-x-6" : "translate-x-1"
              } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
          </Switch>
        </div>

        <p className={`${props.completed ? "text-through" : ""} mx-4 w-full`}>
          {props.text}
        </p>
        <button className="btn btn-delete" onClick={props.onDelete}>
          <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
        </button>
      </li>
    </>
  );
}

export { TodoItem };
